import { useState, useImperativeHandle } from 'react';

import { FormAPI, IValidationStates } from '../../../../../types';

type GetErrorsFn = (isTouched: boolean) => IValidationStates;

export function useValidationHandle(
  ref: React.Ref<FormAPI>,
  getErrors: GetErrorsFn,
  deps: unknown[] = []
): [IValidationStates, React.Dispatch<React.SetStateAction<IValidationStates>>] {
  const [errors, setErrors] = useState<IValidationStates>(() => getErrors(false));

  useImperativeHandle(
    ref,
    () => ({
      validate: () => {
        const currentErrors = getErrors(true);
        const valid = !Object.values(currentErrors).some((e) => e.isError);
        setErrors(currentErrors);
        return valid;
      },
      reset: () => {
        setErrors(getErrors(false));
      },
    }),
    [getErrors, ...deps]
  );

  return [errors, setErrors];
}
